import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

import { checkIsRouteAuthorized } from "@/security/authorization";
import { usePreferencesStore } from "@/stores/preferences";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavbarMenuProjectTab',
  setup(__props) {

const preferencesStore = usePreferencesStore();

const frequentProjects = computed(() => {
  const frequentProjectsArray = Object.entries(
    preferencesStore.frequentProjects
  ).map(([projectId, project]) => ({
    id: projectId,
    ...project,
  }));
  frequentProjectsArray.sort((a, b) =>
    a.count < b.count ? 1 : a.count > b.count ? -1 : 0
  );
  return frequentProjectsArray.slice(0, 5);
});

return { __sfc: true,preferencesStore, frequentProjects, checkIsRouteAuthorized }
}

})